import { render, staticRenderFns } from "./RentalCompanyEdit.vue?vue&type=template&id=36572d87&"
import script from "./RentalCompanyEdit.vue?vue&type=script&lang=js&"
export * from "./RentalCompanyEdit.vue?vue&type=script&lang=js&"
import style0 from "./RentalCompanyEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports